// extracted by mini-css-extract-plugin
export var heading = "styles-module--heading--5500a";
export var inputSearch = "styles-module--inputSearch--649ba";
export var shapeList = "styles-module--shapeList--285ed";
export var shapeNavigation = "styles-module--shapeNavigation--19e3e";
export var subline = "styles-module--subline--cda97";